import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgLock = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      d="M17.177 12.125h-.642v-1.969a4.1 4.1 0 0 0-1.173-2.916 4.14 4.14 0 0 0-2.9-1.24 4.14 4.14 0 0 0-2.899 1.24 4.1 4.1 0 0 0-1.171 2.916v1.97h-.643a1.3 1.3 0 0 0-.916.39 1.3 1.3 0 0 0-.37.921v5.25c-.004.344.129.675.37.921.24.247.57.387.916.392h9.428c.346-.005.675-.145.916-.392.242-.246.375-.577.37-.921v-5.25a1.3 1.3 0 0 0-.37-.92 1.3 1.3 0 0 0-.916-.392m-2.784 0h-3.86v-1.969a1.9 1.9 0 0 1 .547-1.388 1.93 1.93 0 0 1 1.381-.58 1.94 1.94 0 0 1 1.381.58 1.92 1.92 0 0 1 .547 1.388z"
      fill={props.color}
    />
  </Svg>
);
const Memo = memo(SvgLock);
export default Memo;
